import { Cadence } from '../../types/howItWorks';

interface CadenceStyle {
  label: string;
  hex: string;
  text: string;
  bg: string;
  border: string;
  solid: string;
}

export const cadenceStyles: Record<Cadence, CadenceStyle> = {
  quarterly: { label: 'Set quarterly', hex: '#5A1BA9', text: 'text-sf-purple', bg: 'bg-sf-purple-light', border: 'border-[#D9C9F2]', solid: 'bg-sf-purple' },
  monthly: { label: 'Set monthly', hex: '#0176D3', text: 'text-sf-blue-dark', bg: 'bg-sf-blue-light', border: 'border-[#B0CDF5]', solid: 'bg-sf-blue' },
  loan: { label: 'Per loan', hex: '#2E844A', text: 'text-sf-green-text', bg: 'bg-sf-green-light', border: 'border-[#91DB8B]', solid: 'bg-sf-green' },
  period: { label: 'Per period', hex: '#056764', text: 'text-[#056764]', bg: 'bg-[#E6F7F6]', border: 'border-[#9EDBD6]', solid: 'bg-[#056764]' },
};
